import { defineStore } from 'pinia'

const useUserStore = defineStore('user', {
  state: () => ({
    id: null,
    nome: null,
    avatar: null,
    empresaId: null,
  }),

  getters: {
    isLoggedIn: state => !!state.id && !!state.nome && !!state.empresaId,
  },

  actions: {
    setUserData(data) {
      this.id = parseInt(data.id, 10)
      this.nome = data.nome
      this.avatar = data.avatar || null
      this.empresaId = parseInt(data.empresaId, 10)
    },
    setAvatar(avatar) {
      this.avatar = avatar
    },
    clear() {
      this.id = null
      this.nome = null
      this.avatar = null
      this.empresaId = null
    },
  },

  persist: true,
})

export default useUserStore
